// 质检管理
export default [
  {
    path: '/checkOrderSummary',
    name: 'checkOrderSummary',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '@views/qualityControl/voiceSummary'
      ),
    meta: { title: '语音质检汇总', keepAlive: true }
  },
  {
    path: '/checkOrderDetail',
    name: 'checkOrderDetail',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '@views/qualityControl/voiceDetail'
      ),
    meta: { title: '语音质检明细', keepAlive: true }
  },
  {
    path: '/voiceDetailView/:id',
    name: 'voiceDetailView',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '@views/qualityControl/voiceDetailView'
      ),
    meta: { title: '查看语音质检明细', keepAlive: true }
  },
  {
    path: '/voiceDetailHandle/:id',
    name: 'voiceDetailHandle',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '@views/qualityControl/voiceDetailHandle'
      ),
    meta: { title: '复核语音质检明细', keepAlive: true }
  },
]
